import {Theme, createStyles} from '@material-ui/core';

export const footerBarStyles = (theme: Theme) =>
	createStyles({
		root: {
			backgroundColor: 'transparent',
			paddingTop: theme.spacing(4),
			paddingBottom: theme.spacing(3),
			[theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.sm)]: {
				paddingTop: theme.spacing(3),
			},
		},
		toolbar: {},
		pdpLink: {
			color: theme.palette.text.footerLink,
			marginLeft: theme.spacing(6.5),

			[theme.breakpoints.down(theme.breakpoints.values.md)]: {
				marginLeft: 0,
			},
			[theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.sm)]: {
				margin: theme.spacing(1.5, 0),
			},
		},
		link: {
			lineHeight: theme.typography.pxToRem(22),
			color: theme.palette.text.footerLink,
			marginLeft: theme.spacing(6.5),
			[theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.sm)]: {
				fontSize: theme.typography.pxToRem(16),
				marginLeft: theme.spacing(0),
				marginBottom: theme.spacing(1.5),
			},
		},
		xingLink: {
			marginLeft: theme.spacing(2.5),
		},
		socialIcon: {
			color: theme.palette.primary.light,
		},
		leftSide: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-start',
			alignItems: 'center',

			[theme.breakpoints.down(theme.breakpoints.values.md)]: {
				flexDirection: 'column',
				alignItems: 'flex-start',
			},
			[theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.sm)]: {
				justifyContent: 'center',
				alignItems: 'center',
			},
		},
		rightSide: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-end',
			alignItems: 'center',
			[theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.sm)]: {
				flexDirection: 'column',
			},
		},
		iconLinks: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'baseline',
			paddingTop: theme.spacing(3.5),
		},
	});
